module.exports = __webpack_public_path__ + "static/Homebase-8d2f4981467de556acb9b954189e91bb.jpg";